import {
  Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild,
} from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { ToastrService } from 'ngx-toastr';
import { Subscription, Observable } from 'rxjs';
import {
  ILLCustomerCompaniesByTypeWrapper, ILLEstablishment, ILLFormDetail, ILLProduct, ILLRelationship, ICompanyDetail,
} from '../../../../shared/models/index';
import { LLFormService, CompanyContactService } from '../../../../shared/services/index';

@Component({
  selector: 'app-establishment-modal',
  templateUrl: './establishment-modal.component.html',
  styleUrls: ['./establishment-modal.component.scss'],
})
export class EstablishmentModalComponent implements OnInit, OnDestroy, OnChanges {
  modalValWidth = '500px';
  modalValHeight = 'auto';
  public modalValVisible = true;
  public modalValHidden = false;

  target = '#modalTarget';
  ddwFields: Object = { text: 'companyName', value: 'companyRevisionId' };
  position: object = { X: 'center', Y: 'center' };
  modalWidth = '60%';
  modalHeight = '80%';
  animationSettings: Object = { effect: 'Zoom' };
  isModal = true;
  visible = false;
  companyRevisionId: any;
  ddwHeight = '220px';
  companyDataSource: any[] = [];
  estabForm: UntypedFormGroup;
  allEstablishmentCompanies: ILLEstablishment[] = [];
  revisionEstabCompanies: ILLEstablishment[] = [];
  companyCnt: number;
  llFormDetails: ILLFormDetail;
  availableEstabCompaniesCount: number;
  revisionLabelerNdcCode: any;
  productInfoForm: any;
  labelerForm: any;
  establishmentsExist = true;
  ddwCompanySelected = false;
  warningModalText = '';
  iconTypeCompany = true;
  company$: Observable<ICompanyDetail> | null;
  productLabeler: string;
  originalEstabForm: UntypedFormGroup;
  originalFormData: any;
  pageLoaded = false;

  sub: Subscription;

  @ViewChild('modalDialog')
  public modalDialog: DialogComponent;

  @ViewChild('dialog')
  public dialog: DialogComponent;

  @Input() llFormData: ILLFormDetail;
  @Output() modalEstabData = new EventEmitter<any>();
  @Input() changedNdcCode: any;
  @Input() bDeleteProduct: boolean;

  BtnClick: EmitType<object> = () => {
    this.dialog.show();
  };

  ndcProductLinkNotAllowed: boolean;

  constructor(
    private fb: UntypedFormBuilder,
    private toastr: ToastrService,
    private llFormService: LLFormService,
    private companyService: CompanyContactService,
    private llService: LLFormService,
  ) { }

  dlgButtonClick: EmitType<object> = () => {
    this.modalDialog.hide();
  };

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public buttons: Object[] = [{ click: this.dlgButtonClick.bind(this), buttonModel: { content: 'OK', isPrimary: true } }];

  ngOnInit() {
    this.llService.llFormEstablishmentSubject.next(null);
    this.initializeModal();

    this.formProductLabeler();

    this.estabForm.markAsPristine();
  }

  initializeModal() {
    this.sub = this.llFormService.llFormLabelerSubject.subscribe(lb => {
      this.labelerForm = lb;
    });

    this.sub = this.llFormService.llFormProductInformationSubject.subscribe(pi => {
      this.productInfoForm = pi;
    });

    this.estabForm = this.fb.group({
      companies: this.fb.array([this.company]),
    });

    this.setCompaniesDdw();

    // Watches changes on the entire form
    this.estabForm.valueChanges.subscribe(data => {

    });

    if (this.llFormData && this.llFormData[0].data) {
      this.llFormDetails = this.llFormData[0].data;

      this.revisionEstabCompanies = this.llFormDetails.establishments;

      if (this.revisionEstabCompanies && this.revisionEstabCompanies.length > 0) {
        this.estabForm.setControl('companies', this.setOrigCompanies(this.revisionEstabCompanies));
      } else {
        this.establishmentsExist = false;
      }

      // For certain FDA Centers, disable or re-enable some options
      this.ndcProductLinkNotAllowed = this.llFormDetails.fdaCenter.ndcProductLinkNotAllowed;
    }
  }

  setBOs() {
    if (this.companies && this.companies.length > 0) {
      this.companies.controls.forEach((company, c) => {
        if (company.value.companyRevisionId) {
          this.setOrigBOs(company.value.companyRevisionId, c);
        }
      });
    }
  }

  boChkChanged(event, compIndex, boIndex) {
    const checked: boolean = event.checked;

    if (!checked && !this.ndcProductLinkNotAllowed) {
      const products = ((<UntypedFormArray> this.estabForm.controls.companies).at(compIndex).get('busOps') as UntypedFormArray).at(boIndex).get('products') as UntypedFormArray;

      if (products && products.controls.length > 0) {
        products.controls.forEach(product => {
          product.patchValue({ selected: checked });
        });
      }
    }
  }

  productChkChanged(event, ci, bi, pi) {
    const checked: boolean = event.checked;

    const company = (<UntypedFormArray> this.estabForm.controls.companies).at(ci) as UntypedFormArray;
    const bo = ((<UntypedFormArray> this.estabForm.controls.companies).at(ci).get('busOps') as UntypedFormArray).at(bi) as UntypedFormArray;
    const products = ((<UntypedFormArray> this.estabForm.controls.companies).at(ci).get('busOps') as UntypedFormArray).at(bi).get('products') as UntypedFormArray;

    if (products && products.controls.length > 0) {
      products.controls[pi].patchValue({ selected: checked });

      const selectedProducts = products.value.filter(s => s.selected);

      if (selectedProducts && selectedProducts.length) {
        ((<UntypedFormArray> this.estabForm.controls.companies).at(ci).get('busOps') as UntypedFormArray).at(bi).patchValue({ selected: true });
      }

      if (this.llFormData && this.llFormData[0].data) {
        if (this.llFormData[0].data.establishments[ci]) {
          if (this.llFormData[0].data.establishments[ci].businessOperations[bi]) {
            this.llFormData[0].data.establishments[ci].businessOperations[bi] = bo;
          }
        }
      }
    }
  }

  boDisplayed(compIndex, boIndex) {
    const bo = ((<UntypedFormArray> this.estabForm.controls.companies).at(compIndex).get('busOps') as UntypedFormArray).at(boIndex);

    if (bo.value.busOpCode) {
      return true;
    }

    return false;
  }

  setOrigCompanies(estabCompanies: ILLEstablishment[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    let estabCompany: any;

    estabCompanies.forEach((company, i) => {
      estabCompany = this.fb.group({
        companyRevisionId: company.establishmentCompany.companyRevisionId,
        companyName: company.establishmentCompany.companyName,
        confidential: company.confidentiality,
        busOps: this.setOrigBOs(company.establishmentCompany.companyRevisionId, i),
      });
      formArray.push(estabCompany);
    });

    this.companyCnt = formArray.length;
    return formArray;
  }

  get company(): UntypedFormGroup {
    return this.fb.group({
      companyRevisionId: ['', { updateOn: 'blur' }],
      companyName: '',
      confidential: ['N', { updateOn: 'blur' }],
      busOps: this.fb.array([this.busOp]),
    });
  }

  companySelectionChanged(event, i) {
    if (event.isInteracted) {
      if (event.value) {
        this.setOrigBOs(event.value, i);

        this.ddwCompanySelected = true;
      }
    }
  }

  setOrigBOs(companyRevisionId, index) {
    let company: UntypedFormGroup;

    const BOs: UntypedFormArray = <UntypedFormArray> this.setBOForm(companyRevisionId);

    const estab = this.allEstablishmentCompanies.find(c => c.establishmentCompany.companyRevisionId === companyRevisionId);

    const revisionEstab = this.revisionEstabCompanies.find(rc => rc.establishmentCompany.companyRevisionId === companyRevisionId);

    let revisionEstabConfidentiality = false;

    if (revisionEstab) {
      switch (revisionEstab.confidentiality.toString()) {
        case 'N':
          revisionEstabConfidentiality = false;
          break;
        case 'Y':
          revisionEstabConfidentiality = true;
          break;
        case 'true':
          revisionEstabConfidentiality = true;
          break;
        case 'false':
          revisionEstabConfidentiality = false;
          break;
      }
    } else {
      revisionEstabConfidentiality = false;
    }

    company = this.fb.group({
      companyRevisionId: companyRevisionId,
      companyName: revisionEstab ? revisionEstab.establishmentCompany.companyName : (estab ? estab.establishmentCompany.companyName : ''),
      dunsNumber: revisionEstab ? revisionEstab.establishmentCompany.dunsNumber : (estab ? estab.establishmentCompany.dunsNumber : ''),
      confidential: revisionEstabConfidentiality,
      busOps: BOs,
    });

    this.companies.setControl(index, company);
  }

  get busOp(): UntypedFormGroup {
    return this.fb.group({
      busOpId: [''],
      busOpCode: [''],
      busOpLabel: [''],
      businessOperationsCompanyRevisionId: [''],
      selected: [true],
      products: this.fb.array([this.product]),
    });
  }

  get product(): UntypedFormGroup {
    return this.fb.group({
      ndcProductCode: [''],
      selected: [true],
    });
  }

  setBOForm(companyRevisionId: number): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    let establishment: ILLEstablishment;

    if (this.allEstablishmentCompanies && this.allEstablishmentCompanies.length > 0) {
      this.availableEstabCompaniesCount = this.allEstablishmentCompanies.length;

      // check selected busOps and products.
      establishment = this.allEstablishmentCompanies.find(c => c.establishmentCompany.companyRevisionId === companyRevisionId);

      if (establishment && establishment.businessOperations && establishment.businessOperations.length > 0) {
        establishment.businessOperations = establishment.businessOperations.filter((busOp, index, array) => index === array.findIndex((bo) => busOp.businessOperations.id === bo.businessOperations.id));

        establishment.businessOperations.forEach((b: ILLRelationship) => {
          let productsFormArray = new UntypedFormArray([]);

          productsFormArray = this.setProducts(b, companyRevisionId);

          // find if bus op exist in revision estabs
          const estab = this.revisionEstabCompanies.find(c => c.establishmentCompany.companyRevisionId === companyRevisionId);

          const busOp = estab && estab.businessOperations.find(bop => bop.businessOperations?.id === b.businessOperations?.id);

          if (productsFormArray && productsFormArray.length > 0) {
            let boSelected = false;

            if (!this.establishmentsExist) {
              // added establishment
              boSelected = true;
            } else {
              if (busOp && busOp.selected) {
                // busOp exist and selected === true
                boSelected = true;
              } else {
                // busop exists in estab company but not in the revision's establishment
                // if estab doesn't exist it means that the new company is selected from ddw and it doesn't exist in the revision
                boSelected = !estab;
              }
            }

            const boObject: UntypedFormGroup = this.fb.group({
              busOpId: b.businessOperations.id,
              busOpCode: b.businessOperations.code,
              busOpLabel: b.businessOperations.label,
              businessOperationsCompanyRevisionId: b.businessOperations.id,
              selected: boSelected, // !this.establishmentsExist ? true : busOp ? busOp && busOp.selected : true,
              products: [this.fb.array([this.product])],
            });

            boObject.setControl('products', productsFormArray);

            formArray.push(boObject);
          }
        });
      }
    }

    return formArray;
  }

  formProductLabeler() {
    this.sub = this.llFormService.llFormProductLabelerCodeSubject.subscribe(data => {
      const productProductCode = data;
      const productLabelerCode = productProductCode ? productProductCode.split('-')[0] : '';

      this.productLabeler = productLabelerCode;
    });
  }

  setProducts(bo: ILLRelationship, estabCompanyId: number): UntypedFormArray {
    let llProducts: ILLProduct[] = [];
    let establishmentsArray: ILLEstablishment[] = [];
    const productsFormArray = new UntypedFormArray([]);
    let company: ILLEstablishment;
    let ndcProductCodes: string[] = [];
    let companyBo: any;

    if (this.llFormData && this.llFormData[0].data) {
      const llForm: ILLFormDetail = this.llFormData[0].data;

      // enter products from establishments section of dataset
      establishmentsArray = llForm.establishments;

      if (establishmentsArray && establishmentsArray.length > 0) {
        company = establishmentsArray.find(t => t.establishmentCompany.companyRevisionId === estabCompanyId);

        if (company) {
          companyBo = company.businessOperations.find(b => b.businessOperations?.id === bo.businessOperations?.id);

          if (companyBo) {
            if (companyBo.ndcProductCode && companyBo.ndcProductCode.length && companyBo.ndcProductCode[0].ndcProductCode) {
              const uniqueNdcCodes = companyBo.ndcProductCode.map(item => item.ndcProductCode)
                .filter((value, index, self) => self.indexOf(value) === index);

              if (uniqueNdcCodes) {
                ndcProductCodes = uniqueNdcCodes;
              }
            } else {
              ndcProductCodes = companyBo.ndcProductCode;
            }
          }
        }
      } else {
        // no establishments
        company = this.allEstablishmentCompanies.find(t => t.establishmentCompany.companyRevisionId === estabCompanyId);

        companyBo = company.businessOperations.find(b => b.businessOperations.id === bo.businessOperations.id);

        if (companyBo) {
          const uniqueNdcCodes = companyBo.ndcProductCode.map(item => item.ndcProductCode ? item.ndcProductCode : item)
            .filter((value, index, self) => self.indexOf(value) === index);

          if (uniqueNdcCodes) {
            ndcProductCodes = uniqueNdcCodes;
          }
        }
      }

      // enter products from Products array of the llForm
      llProducts = llForm.products;

      if (llProducts && llProducts.length > 0) {
        // commented out this loop, this logic is not needed.
        // Our requirement dictates that user can't open establishment modal popup until they have both labeler code and
        // product code for all the products(kits) on the form. With that, user will not be allowed to open this modal popup
        // if either of labeler code or product code section contains "xxxx".

        // llProducts.forEach((prod, i) => {

        // if product was saved without labeler code - add it.
        // prod.ndcProductCode = prod.ndcProductCode.replace('xxxx', llForm.ndcLabelerCode);

        // commented out the line ABOVE. it could potentially copy labeler code into productCode inside ndProductCode in some cases.
        // e.g. right after cloning a form, after user selected a labeler company (e.g. labelerCode = "12345"), the newly cloned form will have ndcProductCOde
        // like this: "12345-xxxx", the code above will change ndcProductCode to "12345-12345", which is incorrect
        // Added logic to make sure only do the replacement for the labeler code section inside the ndcProduct code
        //     const codes = prod.ndcProductCode.split('-');
        //     prod.ndcProductCode = `${codes[0].replace('xxxx', llForm.ndcLabelerCode)}-${codes[1] ? codes[1] : ''}`;
        // });

        const llProductCodes = llProducts
          .map(item => item.ndcProductCode)
          .filter((value, index, self) => self.indexOf(value) === index);

        // concat array
        ndcProductCodes = ndcProductCodes.filter(p => p.split('-')[0] && p.split('-')[1] && p.split('-')[1] !== 'null' && p.split('-')[0] !== 'xxxx');

        const allCodes = ndcProductCodes.concat(llProductCodes);

        // check uniqueness after both arrays concatenated
        const allCodesUnique = allCodes
          .map(item => item)
          .filter((value, index, self) => self.indexOf(value) === index).filter(c => c).sort();

        if (allCodesUnique && allCodesUnique.length > 0) {
          // const productLabeler = this.formProductLabeler();
          // if (this.productLabeler) {
          //     allCodesUnique = allCodesUnique.filter(l => l.split('-')[0] === this.productLabeler);
          // }

          allCodesUnique.forEach(element => {
            // find if bus op exist in revision estabs
            const estab = this.revisionEstabCompanies.find(c => c.establishmentCompany.companyRevisionId === estabCompanyId);
            let busOpSelected;
            let busOp;

            if (estab) {
              busOp = estab.businessOperations.find(bop => bop.businessOperations?.id === bo.businessOperations?.id);

              if (busOp) {
                busOpSelected = busOp.selected;
              }
            } else {
              // estab added by the Add Company button
              busOpSelected = true;
            }

            if (element && element.split('-')[1] && element.split('-')[1] !== 'null') {
              const product: UntypedFormGroup = this.fb.group({
                ndcProductCode: `${element}`,
                selected: this.establishmentsExist ? (!!((ndcProductCodes.indexOf(element) >= 0 || !estab) && busOpSelected && !this.ndcProductLinkNotAllowed)) : !this.ndcProductLinkNotAllowed,
              });

              productsFormArray.push(product);
            }
          });
        }
      }
    }

    return productsFormArray;
  }

  compare(a, b) {
    if (a.establishmentCompany.companyName < b.establishmentCompany.companyName) {
      return -1;
    }
    if (a.establishmentCompany.companyName > b.establishmentCompany.companyName) {
      return 1;
    }
    return 0;
  }

  setCompaniesDdw() {
    this.companyDataSource = [];

    if (this.llFormData && this.llFormData[2].data) {
      const companyTypes: ILLCustomerCompaniesByTypeWrapper = this.llFormData[2].data;

      // unique companies
      // this.allEstablishmentCompanies = Array.from(new Set(companyTypes.establishments.concat(companyTypes.establishmentsThirdParty))).sort(this.compare);

      this.allEstablishmentCompanies = companyTypes.establishmentOwnedAndEstablishmentThirdParty;

      this.availableEstabCompaniesCount = this.allEstablishmentCompanies.length;
    }

    if (this.allEstablishmentCompanies && this.allEstablishmentCompanies.length > 0) {
      this.allEstablishmentCompanies.forEach((est: ILLEstablishment) => {
        const ds = { companyRevisionId: 0, companyName: '' };
        ds.companyRevisionId = +est.establishmentCompany.companyRevisionId;
        ds.companyName = est.establishmentCompany.companyName;

        this.companyDataSource.push(ds);
      });
    }
  }

  get companies(): UntypedFormArray {
    return this.estabForm.get('companies') as UntypedFormArray;
  }

  get companyFormControls() {
    return this.companies.controls;
  }

  busOpsArray(boIndex: number): UntypedFormArray {
    const arr = this.companies.at(boIndex).get('busOps') as UntypedFormArray;

    return arr;
  }

  busOpsArrayChkVisible(boIndex: number): boolean {
    const arr = this.companies.at(boIndex).get('busOps') as UntypedFormArray;

    const val = arr.controls[0].value.products.filter(p => p.ndcProductCode).length > 0;

    return val;
  }

  productsArray(compIndex: number, boIndex: number): UntypedFormArray {
    const arr = ((<UntypedFormArray> this.estabForm.controls.companies).at(compIndex).get('busOps') as UntypedFormArray).at(boIndex).get('products') as UntypedFormArray;

    return arr;
  }

  productsArrayChkVisible(compIndex: number, boIndex: number): boolean {
    const arr = ((<UntypedFormArray> this.estabForm.controls.companies).at(compIndex).get('busOps') as UntypedFormArray).at(boIndex).get('products') as UntypedFormArray;

    const val = arr.controls[0].value.ndcProductCode;

    return val;
  }

  addCompany(): void {
    this.companies.push(this.company);
    this.companyCnt++;
  }

  removeCompany(event, i) {
    this.companies.removeAt(i);
    this.companyCnt--;
  }

  isDuplicateCompanies(): boolean {
    let isDuplicate: boolean;

    const valueArr = this.companies.controls.map(function (item) {
      return item.value.companyRevisionId;
    });

    isDuplicate = valueArr.some(function (item, idx) {
      return valueArr.indexOf(item) !== idx;
    });

    return isDuplicate;
  }

  saveEstab(form: UntypedFormGroup, cancel?: boolean) {
    let errorMessage;

    if (this.isDuplicateCompanies()) {
      errorMessage = 'Establishments are not unique. Please remove duplicates.';
    }

    if (!this.areCompaniesLatest() && !cancel) {
      errorMessage = 'One of the establishment companies is missing or not the latest revision.';
    }

    if (!errorMessage) {
      this.modalEstabData.emit({ estabForm: form.value, originalFormData: this.originalFormData, cancel: cancel });

      this.establishmentsExist = form.value.companies.length > 0;

      this.visible = false;

      this.dialog.hide();
    } else {
      this.toastr.error(errorMessage);
      this.pageLoaded = true;
    }
  }

  // Check if the previously saved company is the latest version
  areCompaniesLatest() {
    const notLatestCompanies = [];

    const valueArr = this.companies.controls.map(function (item) {
      return item.value.companyRevisionId;
    });

    if (valueArr && valueArr.length) {
      valueArr.forEach(element => {
        const company = this.allEstablishmentCompanies.find(x => x.establishmentCompany.companyRevisionId === element);

        if (!company) {
          notLatestCompanies.push(element);
        }
      });
    }

    return notLatestCompanies.length === 0;
  }

  // Check if the previously saved company is the latest version
  isCompanyLatest(companyRevisionId: number) {
    if (companyRevisionId) {
      const company = this.allEstablishmentCompanies.find(x => x.establishmentCompany.companyRevisionId === companyRevisionId);

      if (!company) {
        return false;
      }
    }

    return true;
  }

  dlgBtnClick: EmitType<object> = () => {
    this.dialog.hide();
  };

  estabModalCancel(event) {
    this.visible = false;
    this.dialog.hide();

    this.saveEstab(this.originalEstabForm, true);
  }

  onDialogCreated(event) {
    this.estabForm.reset();
    this.companies.reset();
    this.busOp.reset();
    this.product.reset();
  }

  onDialogDestroyed(event) {
    this.estabForm.reset();
    this.companies.reset();
    this.busOp.reset();
    this.product.reset();
  }

  onOverlayClick: EmitType<object> = () => {
    this.modalDialog.hide();
  };

  onDialogOpen(event) {
    this.pageLoaded = false;

    this.initializeModal();

    if (this.companies && this.companies.length > 0) {
      this.companies.controls.forEach((company, c) => {
        if (company.value.companyRevisionId) {
          this.setOrigBOs(company.value.companyRevisionId, c);
        }
      });

      // store the original state of the form for the canceling event.
      this.originalEstabForm = this.llService.cloneAbstractControl(this.estabForm);
      this.originalFormData = this.llService.deepCopy(this.llFormData[0].data);
    }

    this.pageLoaded = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    // eslint-disable-next-line guard-for-in
    for (const property in changes) {
      switch (property) {
        case 'changedNdcCode':
          // We only update the data when the current ndcProductCode is not empty
          if (changes[property].currentValue && changes[property].currentValue.split('|')[1]) {
            this.updateEstablishments();
          }
          break;

        case 'bDeleteProduct':
          this.updateEstablishments();
          break;

        default:
          break;
      }
    }
  }

  // Update establishment information for LL form
  updateEstablishments() {
    this.initializeModal();
    this.formProductLabeler();
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
